module.exports = __webpack_public_path__ + "static/media/refresh.c0c93329.svg";